module.exports = __webpack_public_path__ + "static/img/logon02.529221b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload/cache_image/default/octweb2000-1-1-/logon02.jpg
// module id = 2KCr
// module chunks = 1